import { render, staticRenderFns } from "./PatentAnnuityStatus.vue?vue&type=template&id=c92ec004&"
import script from "./PatentAnnuityStatus.vue?vue&type=script&lang=js&"
export * from "./PatentAnnuityStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports